import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Subject } from "rxjs";
import { Route, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { CommonService } from './common.service';
import { SpinnerVisibilityService } from 'ng-http-loader';

@Injectable({
  providedIn: 'root'
})
export class RestaurantService {

  url: any = environment.API_URL;
  stripePromise: Promise<Stripe>;
  stripeToken = 'pk_test_51Rfo41PLIPq0nHQwiNsG6dmzxeenbE8jfMHq44mtbzpIx6BDf4Z4skUZHlQbC7iotk5tSgGb2DnMeh7pXicbQo2T004oIuB8Gl';
  // stripeToken = 'pk_live_51Mwn3PF6k8u4g0kS8U3F1BZZIHblly6KtVP0t6REcMet7QsvPs6ZUs2MMuhZNbSAwz8YzAUlSv5OGu81VlQNUp4u00MBnKvE4H';
  constructor(
    private http: HttpClient,
    private csObj: CommonService,
    private spinner: SpinnerVisibilityService,
    private authService: AuthService,
    private route: Router,

  ) {
    this.stripePromise = loadStripe(this.stripeToken);
  }

  getStripeInstance(): Promise<Stripe> {
    return this.stripePromise;
  }

  stripeGenerateToken(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${this.stripeToken}`
      })
    };
    return this.http.post('https://api.stripe.com/v1/tokens', data, httpOptions)
  }

  getNewOrders(data: any) {
    return this.http.post(this.url + 'restaurant/newOrders', data);
  }

  getNewOrderById(id: any) {
    return this.http.get(this.url + 'restaurant/orderDetailsById/' + id);
  }


  acceptOrder(data: any) {
    return this.http.post(this.url + 'restaurant/acceptOrder', data);
  }

  confirmDelivered(data: any) {
    return this.http.post(this.url + 'restaurant/confirmDelivered', data);
  }



  declineOrder(data: any) {
    return this.http.post(this.url + 'restaurant/declinedOrders', data);
  }

  cancleOrderByResto(data: any) {
    return this.http.post(this.url + 'restaurant/declineOrder', data);
  }

  getUpcomingOrders(data: any) {
    return this.http.post(this.url + 'restaurant/upcomingOrders', data);
  }
  getUpcomingEvents(data: any) {
    return this.http.post(this.url + 'restaurant/upcomingEvents', data);
  }
  markAllAsDelivered(data: any) {
    return this.http.post(this.url + 'restaurant/all-Delivered', data);
  }

  getDeliveredOrders(data: any) {
    return this.http.post(this.url + 'restaurant/deliveredOrders', data);
  }

  getClubProfiles(data) {
    return this.http.post(this.url + 'restaurant/clubProfileList', data);
  }


  getBanckingDetails() {
    return this.http.get(this.url + 'restaurant/bankDetails');
  }

  getRestaurantNotification() {
    return this.http.get(this.url + 'restaurant/getNotifications');
  }

  updateBanckDetails(data) {
    return this.http.put(this.url + 'restaurant/bankDetails', data);
  }

  loginToStripe() {
    return this.http.get(this.url + 'restaurant/stripeLoginUrl');
  }

  connectToStripe(data: any) {
    return this.http.post(this.url + 'restaurant/connectAccount', data);
  }

  unlinkToStripe() {
    return this.http.delete(this.url + 'restaurant/unlink');
  }


  getBankDetails() {
    return this.http.get(this.url + 'restaurant/bankAccount');
  }


  updateBankDetails(data: any) {
    return this.http.put(this.url + 'restaurant/update/bankAccount', data);
  }


  getPaymentDetails() {
    return this.http.get(this.url + 'restaurant/paymentsDetails');
  }

  getPaymentAmount() {
    return this.http.get(this.url + 'restaurant/paymentsAmount');
  }


  getProducts() {
    return this.http.get(this.url + 'restaurant/stripeLoginUrl');
  }


  newOrderSchools() {
    return this.http.get(this.url + 'restaurant/getNewOrdersSchools');
  }

  getDeclineOrdersSchools() {
    return this.http.get(this.url + 'restaurant/getDeclineOrdersSchools');
  }

  newOrderEvents(id: any) {
    return this.http.get(this.url + 'restaurant/getNewOrdersEvents/' + id);
  }

  declineOrderEvents(id: any) {
    return this.http.get(this.url + 'restaurant/getDeclineOrdersEvents/' + id);
  }

  upcomingOrderSchools() {
    return this.http.get(this.url + 'restaurant/getUpcomingOrdersSchools');
  }

  upcomingOrderEvents(id: any) {
    return this.http.get(this.url + 'restaurant/getUpcomingOrdersEvents/' + id);
  }

  completedOrderEvents(id: any) {
    return this.http.get(this.url + 'restaurant/getCompletedOrdersEvents/' + id);
  }

  completeOrderSchools() {
    return this.http.get(this.url + 'restaurant/getCompletedOrdersSchools');
  }

  completeOrderEvents() {
    return this.http.get(this.url + 'restaurant/getCompletedOrdersEvents');
  }


  uploadToDrive(file: any) {
    let data = {
      file
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream'
      })
    };

    return this.http.post('https://www.googleapis.com/upload/drive/v3/files?uploadType=media', data, httpOptions);
  }





}
